/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthPlatformRemotePatient
 */
export interface PalAuthPlatformRemotePatient {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    middle_initial?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    dob?: string;
    /**
     * 
     */
    member_number?: string;
    /**
     * 
     */
    contract_name?: string;
    /**
     * 
     */
    medicare_id?: string;
    /**
     * 
     */
    eligibility?: string;
    /**
     * 
     */
    start_date?: string;
    /**
     * 
     */
    end_date?: string;
    /**
     * 
     */
    not_managed_by_portal?: boolean;
    /**
     * 
     */
    platform_message?: string;
    /**
     * 
     */
    required_additional_categories?: Array<string>;
}

/**
 * Check if a given object implements the PalAuthPlatformRemotePatient interface.
 */
export function instanceOfPalAuthPlatformRemotePatient(value: object): value is PalAuthPlatformRemotePatient {
    return true;
}

export function PalAuthPlatformRemotePatientFromJSON(json: any): PalAuthPlatformRemotePatient {
    return PalAuthPlatformRemotePatientFromJSONTyped(json, false);
}

export function PalAuthPlatformRemotePatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthPlatformRemotePatient {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'middle_initial': json['middle_initial'] == null ? undefined : json['middle_initial'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'dob': json['dob'] == null ? undefined : json['dob'],
        'member_number': json['member_number'] == null ? undefined : json['member_number'],
        'contract_name': json['contract_name'] == null ? undefined : json['contract_name'],
        'medicare_id': json['medicare_id'] == null ? undefined : json['medicare_id'],
        'eligibility': json['eligibility'] == null ? undefined : json['eligibility'],
        'start_date': json['start_date'] == null ? undefined : json['start_date'],
        'end_date': json['end_date'] == null ? undefined : json['end_date'],
        'not_managed_by_portal': json['not_managed_by_portal'] == null ? undefined : json['not_managed_by_portal'],
        'platform_message': json['platform_message'] == null ? undefined : json['platform_message'],
        'required_additional_categories': json['required_additional_categories'] == null ? undefined : json['required_additional_categories'],
    };
}

export function PalAuthPlatformRemotePatientToJSON(json: any): PalAuthPlatformRemotePatient {
    return PalAuthPlatformRemotePatientToJSONTyped(json, false);
}

export function PalAuthPlatformRemotePatientToJSONTyped(value?: PalAuthPlatformRemotePatient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'middle_initial': value['middle_initial'],
        'last_name': value['last_name'],
        'dob': value['dob'],
        'member_number': value['member_number'],
        'contract_name': value['contract_name'],
        'medicare_id': value['medicare_id'],
        'eligibility': value['eligibility'],
        'start_date': value['start_date'],
        'end_date': value['end_date'],
        'not_managed_by_portal': value['not_managed_by_portal'],
        'platform_message': value['platform_message'],
        'required_additional_categories': value['required_additional_categories'],
    };
}

